<div class="partner-slides ptb-100 container">
    

    <div class="container">
        <div class="section-title text-center">
            <span class="sub-title" i18n>Sponsors of Our Projects</span>
            <h2 i18n>Our Donors</h2>
        </div>
    </div>
    <owl-carousel-o [options]="partnerSlides">
        <ng-template carouselSlide *ngFor="let donor of donors">
            <div class="single-partner-item">
                <a href="#" target="_blank" class="d-block">
                    <img src="{{imageUrl}}{{donor.image}}" alt="{{donor.title}}">
                </a>
            </div>
        </ng-template>
    </owl-carousel-o>
</div>